import { ParamMap } from '@angular/router';

import { createFeatureSelector, createSelector, Selector } from '@ngrx/store';
import { routerFeatureKey } from './router.reducer';

import { RouterState } from './router.state';

export const selectRouterState = createFeatureSelector<RouterState>(routerFeatureKey);

export const selectParamMap: Selector<object, ParamMap> = createSelector(
  selectRouterState,
  (router) => router.router?.state?.paramMap
);

export const selectUrl: Selector<object, string> = createSelector(
  selectRouterState,
  (router) => router.router?.state?.url
);

export const selectQueryParamMap: Selector<object, ParamMap> = createSelector(
  selectRouterState,
  (router) => router.router?.state?.queryParamsMap
);

export const selectRouterParam = (param: string) =>
  createSelector(selectParamMap, selectQueryParamMap, (paramMap, queryParams) =>
    paramMap?.has(param) ? paramMap.get(param) : queryParams?.has(param) ? queryParams.get(param) : null
  );
